import React from 'react';
import { useTranslation } from 'react-i18next';

import useContent from '@/utils/hooks/contact';
import Newsletter from '@/components/Newsletter';

import {
  Container,
  Column,
  Title,
  Item,
  LinkItem,
  ExternalLinkItem,
} from './styles';

const Footer = () => {
  const content = useContent();
  const { t } = useTranslation('footer');

  return (
    <Container>
      <Column>
        <Title>{t('copyright')}</Title>
        <Item>{`© ${new Date().getFullYear()}`}</Item>
        <Item>{t('medignition')}</Item>
      </Column>
      <Column>
        <Title>{t('sitemap')}</Title>
        <Item>
          <LinkItem to="/">{t('home')}</LinkItem>
        </Item>
        <Item>
          <LinkItem to="/what-we-do">{t('what')}</LinkItem>
        </Item>
        <Item>
          <LinkItem to="/how-we-work">{t('how')}</LinkItem>
        </Item>
        <Item>
          <LinkItem to="/who-we-are">{t('who')}</LinkItem>
        </Item>
        <Item>
          <LinkItem to="/insights">{t('insights')}</LinkItem>
        </Item>
        <Item>
          <LinkItem to="/contacts">{t('contact')}</LinkItem>
        </Item>
      </Column>
      <Column>
        <Title>{t('info')}</Title>
        <Item>
          <ExternalLinkItem href={content.common.phone.url}>
            {content.common.phone.name}
          </ExternalLinkItem>
        </Item>
        <Item>
          <ExternalLinkItem href={content.common.email.url}>
            {content.common.email.name}
          </ExternalLinkItem>
        </Item>
        <Item>
          <LinkItem to="/imprint">{t('imprint')}</LinkItem>
        </Item>
        <Item>
          <LinkItem to="/terms">{t('terms')}</LinkItem>
        </Item>
        <Item>
          <LinkItem to="/privacy">{t('privacy')}</LinkItem>
        </Item>
      </Column>
      <Newsletter />
    </Container>
  );
};

export default Footer;
